import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// Порядок важен: лист первым, оболочка второй. Оболочка переопределяет
// раскладку .toolbar, заданную под ширину листа.
import './form344/sheet.css';
import './app.css';

const root = document.getElementById('root');
if (!root) throw new Error('Разметка страницы не содержит корневого элемента');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
